/** What a report is about. */
export const FEEDBACK_REPORT_KINDS = ["bug", "idea", "other"] as const;

/** What a report is about: something broken, a suggestion, or anything else. */
export type FeedbackReportKind = (typeof FEEDBACK_REPORT_KINDS)[number];

/** The longest message a report may carry. */
export const FEEDBACK_REPORT_MAX_MESSAGE_LENGTH = 4000;

/** The body of a request to send a report. */
export interface CreateFeedbackReportBody {
  /** Chosen by the client: sending the same report again stores it once. */
  id: string;
  kind: FeedbackReportKind;
  message: string;
  /** The path of the page the person was on. */
  page?: string;
  /** The version of the app they were using. */
  app_version?: string;
  /** The result the report is about (a user_event_verification id). */
  user_event_verification_id?: string;
}
